export default __webpack_public_path__ + "static/media/43.eab6c35d.png";